import Link from 'next/link'

import Card from 'components/saquon/card'
import Wrapper from 'components/saquon/wrapper'
import SectionFooterSeparator from 'components/saquon/section-footer-separator'
import { Icon, Button, Typography } from '~ui'
import { legacyCards } from '../data'

import styles from './Legacy.module.scss'

const { Text } = Typography

const LegacyExperience = () => (
  <section id="legacy">
    <Wrapper>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>
          <Icon name="double-left-arrow" fill="currentColor" width="1em" height="1em" />
          <div>The Legacy Experiences</div>
          <Icon name="double-right-arrow" fill="currentColor" width="1em" height="1em" />
        </h2>
        <div className={styles.subtitle}>
          <Text color="g-white" size="lg" center>
            Ready to go big? Bid on a Legacy Experience and get the chance to hit the gym for leg
            day or get out of the house and enjoy a meal with Saquon. Each experience comes with a
            limited edition 1/1 Rookie NFT.
          </Text>
        </div>

        <div className={styles.cards}>
          {legacyCards.map((item) => (
            <Card key={item.title} {...item}>
              <Link legacyBehavior href={item.link}>
                <a>
                  <Button variant="primary">Place bid</Button>
                </a>
              </Link>
            </Card>
          ))}
        </div>
      </div>
    </Wrapper>
    <SectionFooterSeparator />
  </section>
)

export default LegacyExperience
